"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FileDownload = FileDownload;
var _react = _interopRequireDefault(require("react"));
var _shared = require("../shared");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
//
// Main component
// -------------------------------------------------------------------------------------------------

function FileDownload({
  color,
  size = 1,
  variant = 'solid'
}) {
  if (variant === 'solid') {
    return /*#__PURE__*/_react.default.createElement(_shared.SVG, {
      heightAndWidth: size,
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 24 24"
    }, /*#__PURE__*/_react.default.createElement(_shared.Path, {
      d: "M18 12.08V4.586L13.414 0H2C.897 0 0 .898 0 2v18c0 1.103.897 2 2 2h10.683A6.962 6.962 0 0112 19c0-3.526 2.609-6.434 6-6.92zM9 15H3v-2h6v2zm3-4H3V9h9v2zm0-10l5 5h-5V1z",
      fillColor: color
    }), /*#__PURE__*/_react.default.createElement(_shared.Path, {
      d: "M22.293 17.292L20 19.585V14h-2v5.585l-2.293-2.293-1.414 1.414L19 23.413l4.707-4.707z",
      fillColor: color
    }));
  }
  return /*#__PURE__*/_react.default.createElement(_shared.SVG, {
    heightAndWidth: size,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/_react.default.createElement(_shared.Path, {
    d: "M4 9h8v2H4zM4 13h6v2H4z",
    fillColor: color
  }), /*#__PURE__*/_react.default.createElement(_shared.Path, {
    d: "M16 6v6h2V4.586L13.414 0H2C.897 0 0 .898 0 2v18c0 1.103.897 2 2 2h10v-2H2V2h10v4h4zM22.293 17.293L20 19.586V14h-2v5.586l-2.293-2.293-1.414 1.414L19 23.414l4.707-4.707z",
    fillColor: color
  }));
}